// Client-side Sentry initialization for Next.js
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
//
// OTel tracer imported FIRST so its WebTracerProvider is registered as the
// global tracer before Sentry.init runs. Both SDKs end up patching `fetch`;
// having OTel patch first means OTel owns the W3C `traceparent` header on
// outgoing requests (Sentry uses `sentry-trace`/`baggage` separately).
;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/:locale\",\"regex\":\"^/([^/]+)$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/access-denied\",\"regex\":\"^/([^/]+)/access-denied$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/accounts\",\"regex\":\"^/([^/]+)/accounts$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/accounts/:productId\",\"regex\":\"^/([^/]+)/accounts/([^/]+)$\",\"paramNames\":[\"locale\",\"productId\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/exchange\",\"regex\":\"^/([^/]+)/exchange$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/exchange/:pricingRequestId\",\"regex\":\"^/([^/]+)/exchange/([^/]+)$\",\"paramNames\":[\"locale\",\"pricingRequestId\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/exchange/:pricingRequestId/success\",\"regex\":\"^/([^/]+)/exchange/([^/]+)/success$\",\"paramNames\":[\"locale\",\"pricingRequestId\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/pay\",\"regex\":\"^/([^/]+)/pay$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/pay/:type/:beneficiaryId\",\"regex\":\"^/([^/]+)/pay/([^/]+)/([^/]+)$\",\"paramNames\":[\"locale\",\"type\",\"beneficiaryId\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/pay/:type/:beneficiaryId/:pricingRequestId\",\"regex\":\"^/([^/]+)/pay/([^/]+)/([^/]+)/([^/]+)$\",\"paramNames\":[\"locale\",\"type\",\"beneficiaryId\",\"pricingRequestId\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/pay/:type/:beneficiaryId/:pricingRequestId/success\",\"regex\":\"^/([^/]+)/pay/([^/]+)/([^/]+)/([^/]+)/success$\",\"paramNames\":[\"locale\",\"type\",\"beneficiaryId\",\"pricingRequestId\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/recipient\",\"regex\":\"^/([^/]+)/recipient$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/recipient/:type/:recipientId\",\"regex\":\"^/([^/]+)/recipient/([^/]+)/([^/]+)$\",\"paramNames\":[\"locale\",\"type\",\"recipientId\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/recipient/new\",\"regex\":\"^/([^/]+)/recipient/new$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/settings\",\"regex\":\"^/([^/]+)/settings$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/support\",\"regex\":\"^/([^/]+)/support$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/onboarding\",\"regex\":\"^/([^/]+)/onboarding$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/onboarding/business/account-use\",\"regex\":\"^/([^/]+)/onboarding/business/account-use$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/onboarding/business/company-address\",\"regex\":\"^/([^/]+)/onboarding/business/company-address$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/onboarding/business/company-details\",\"regex\":\"^/([^/]+)/onboarding/business/company-details$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/onboarding/business/contact-details\",\"regex\":\"^/([^/]+)/onboarding/business/contact-details$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/onboarding/business/incoming-payments\",\"regex\":\"^/([^/]+)/onboarding/business/incoming-payments$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/onboarding/business/outgoing-payments\",\"regex\":\"^/([^/]+)/onboarding/business/outgoing-payments$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/onboarding/business/primary-contact\",\"regex\":\"^/([^/]+)/onboarding/business/primary-contact$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/onboarding/business/processing\",\"regex\":\"^/([^/]+)/onboarding/business/processing$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/onboarding/business/review\",\"regex\":\"^/([^/]+)/onboarding/business/review$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/onboarding/business/success\",\"regex\":\"^/([^/]+)/onboarding/business/success$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/onboarding/business/terms\",\"regex\":\"^/([^/]+)/onboarding/business/terms$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/onboarding/business/type\",\"regex\":\"^/([^/]+)/onboarding/business/type$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/onboarding/personal/account-use\",\"regex\":\"^/([^/]+)/onboarding/personal/account-use$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/onboarding/personal/contact-details\",\"regex\":\"^/([^/]+)/onboarding/personal/contact-details$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/onboarding/personal/home-address\",\"regex\":\"^/([^/]+)/onboarding/personal/home-address$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/onboarding/personal/incoming-payments\",\"regex\":\"^/([^/]+)/onboarding/personal/incoming-payments$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/onboarding/personal/outgoing-payments\",\"regex\":\"^/([^/]+)/onboarding/personal/outgoing-payments$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/onboarding/personal/processing\",\"regex\":\"^/([^/]+)/onboarding/personal/processing$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/onboarding/personal/review\",\"regex\":\"^/([^/]+)/onboarding/personal/review$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/onboarding/personal/success\",\"regex\":\"^/([^/]+)/onboarding/personal/success$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/onboarding/personal/terms\",\"regex\":\"^/([^/]+)/onboarding/personal/terms$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/onboarding/status\",\"regex\":\"^/([^/]+)/onboarding/status$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/onboarding/verification\",\"regex\":\"^/([^/]+)/onboarding/verification$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/logged-out\",\"regex\":\"^/([^/]+)/logged-out$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/register\",\"regex\":\"^/([^/]+)/register$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/register/account-type\",\"regex\":\"^/([^/]+)/register/account-type$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/register/capabilities\",\"regex\":\"^/([^/]+)/register/capabilities$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/register/company-details\",\"regex\":\"^/([^/]+)/register/company-details$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/register/email\",\"regex\":\"^/([^/]+)/register/email$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/register/mobile\",\"regex\":\"^/([^/]+)/register/mobile$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/register/name\",\"regex\":\"^/([^/]+)/register/name$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/register/password\",\"regex\":\"^/([^/]+)/register/password$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/register/processing\",\"regex\":\"^/([^/]+)/register/processing$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/register/verification\",\"regex\":\"^/([^/]+)/register/verification$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/test-fixtures/missing-translation\",\"regex\":\"^/([^/]+)/test-fixtures/missing-translation$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/welcome\",\"regex\":\"^/([^/]+)/welcome$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true}],\"staticRoutes\":[],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.1.1";globalThis["_sentryRewritesTunnelPath"] = "/monitoring";import "@/lib/otel/tracer";
import "@/lib/otel/logger";

import { trace } from "@opentelemetry/api";
import * as Sentry from "@sentry/nextjs";

import { setupSessionRecordingOptimizations } from "./lib/analytics";
import { bffPropagationTargets } from "./lib/bffTransport";
import {
  installAppReadyMeasurement,
  shouldCreateSpanForRequest,
} from "./lib/bootTelemetry";
import { installLazySentryReplay } from "./lib/lazySentryReplay";
// The async-recorder Mixpanel entry: keeps rrweb off this pre-hydration chunk.
// lib/analytics.ts imports the same module — never import `mixpanel-browser`.
import mixpanel, {
  MIXPANEL_RECORDER_SRC,
  startSessionRecordingAfterLoad,
} from "./lib/mixpanelClient";
import {
  sanitizeUrlForTelemetry,
  SHARED_DENY_URLS,
  SHARED_IGNORE_ERRORS,
  sharedBeforeSend,
} from "./lib/sentry-shared";
import { resolveClientTelemetry } from "./lib/telemetryGates";
import { installTranslationDomPatch } from "./lib/translation-dom-patch";
import { isInAppBrowser } from "./utils/detectInAppBrowser";

// Eagerly install the DOM patch so it's active before the first React
// render. Makes `Node.removeChild` / `Node.insertBefore` resilient to
// browser translation extensions (Chrome translate, Google Translate)
// that wrap text nodes in `<font>` elements. Prevents the
// `NotFoundError: Failed to execute 'removeChild' on 'Node'` family of
// commit-phase crashes (Sentry CUSTOMER-UI-32). See
// `apps/web/lib/translation-dom-patch.ts` for the patch detail and
// `.claude/rules/web/translation-tolerance.md` for the policy.
installTranslationDomPatch();

// Gate predicates (incl. mock mode: never report a fake-user MSW session) live
// in `lib/telemetryGates.ts`, where every branch is unit-tested.
const telemetry = resolveClientTelemetry();

const isMixpanelEnabled = telemetry.mixpanel;

if (isMixpanelEnabled) {
  mixpanel.init("db95c2847620534784ce4867a7812403", {
    autocapture: true,
    // 0 only until the page settles: startSessionRecordingAfterLoad (below)
    // sets 100 and starts the recorder after load + idle, so its script
    // (our self-hosted recorder_src, below) stays off the first load.
    // Every session is still recorded — see lib/mixpanelClient.ts.
    record_sessions_percent: 0,
    record_idle_timeout_ms: 300_000, // 5 minutes (default is 30 min)
    recorder_src: MIXPANEL_RECORDER_SRC, // self-hosted, pinned; see lib/mixpanelClient.ts
    api_host: "https://api-eu.mixpanel.com",
    // Track all users (anonymous + authenticated). Anonymous sessions use a $device_id,
    // which gets linked to the user's UUID when they authenticate via identifyUser().
    track_pageview: "url-with-path",
  });

  setupSessionRecordingOptimizations();
  startSessionRecordingAfterLoad();
}

// On in deployed production and uat. Off on localhost, non-deployed envs, E2E
// test builds and mock mode. The `environment` tag distinguishes uat/prod.
const sentryEnvironment = telemetry.environment;
const isSentryEnabled = telemetry.sentry;

// Session-replay kill-switch. Replay (rrweb) is the prime suspect for the iOS
// `RangeError: Maximum call stack size exceeded` reported in CUSTOMER-UI-3T —
// its DOM walk recurses, and iOS WebKit's call-stack limit is far smaller than
// desktop V8. Set NEXT_PUBLIC_DISABLE_SENTRY_REPLAY=true in deployed UAT to A/B
// whether removing replay silences the iOS stack-overflow group (Mixpanel
// recording toggles independently via NEXT_PUBLIC_DISABLE_MIXPANEL_UAT). It
// skips the lazy load (installLazySentryReplay below), so the replay chunk is
// never fetched. Leaves the 100%-sampling invariant untouched — it removes the
// integration, not the rate. See `.claude/docs/incident-log.md` (2026-06) and `.claude/rules/web/analytics.md`.
const isSentryReplayEnabled =
  process.env.NEXT_PUBLIC_DISABLE_SENTRY_REPLAY !== "true";

// console.info, not warn: the OTel log bridge (lib/otel/logger.ts) forwards
// warn/error only, so a warn here cost a Kibana WARN and a /diag/logs post to
// the BFF on every pageload for a line that is purely a dev aid.
// eslint-disable-next-line no-console -- deliberately below the bridge's warn floor
console.info(
  "[Sentry] client SDK",
  isSentryEnabled ? "enabled" : "disabled",
  "for environment:",
  sentryEnvironment,
  "| replay:",
  isSentryReplayEnabled ? "on" : "off"
);

Sentry.init({
  dsn: "https://11e492638f640e475b53ac7adf239649@o4510705308794880.ingest.de.sentry.io/4510714393657424",
  enabled: isSentryEnabled,
  release: process.env.NEXT_PUBLIC_SENTRY_RELEASE,
  environment: sentryEnvironment,
  integrations: [
    // Replaces the SDK's default browserTracingIntegration (user integrations
    // win by name), so keep Next's own export. Telemetry beacons get no span —
    // see lib/bootTelemetry.ts.
    Sentry.browserTracingIntegration({ shouldCreateSpanForRequest }),
    // One release-health session per page load. The default ("route") starts
    // a new session — one /monitoring envelope through the SSR Lambda — on
    // every URL-changing pushState/replaceState, including query-only nuqs
    // writes (/pay search keystrokes, exchange sell/buy). Replaces the default
    // integration by name. Session counts and crash-free rates are per page
    // load since 2026-10.
    Sentry.browserSessionIntegration({ lifecycle: "page" }),
    // Replay is NOT listed here: installLazySentryReplay (below) attaches it
    // after `load`, keeping rrweb out of the pre-hydration chunk.
    // Browser profiling was removed 2026-10: it emitted nothing without a
    // `Document-Policy: js-profiling` document header, which nothing sets.
    // Re-adding it needs both the integration and that header.
  ],
  tracesSampleRate: 1.0,
  // OTel browser SDK owns W3C traceparent propagation. Leaving this at its
  // default `false` prevents Sentry and OTel both writing competing
  // `traceparent` headers on the same fetch (race condition in the patch
  // order would split the trace ID across two backends).
  propagateTraceparent: false,
  // Same-origin relative URLs, plus the BFF origin every BFF call goes to
  // (lib/bffTransport.ts), so `sentry-trace`/`baggage` reach the BFF. OTel
  // still writes `traceparent` (propagateTraceparent above). The BFF's CORS
  // allowedHeaders admit both headers.
  tracePropagationTargets: [/^\//, ...bffPropagationTargets()],
  // Read by Replay when it attaches lazily (client.addIntegration), so they
  // still apply. Keep both at 1.0 — the 100% sampling invariant.
  replaysSessionSampleRate: 1.0,
  replaysOnErrorSampleRate: 1.0,
  sendDefaultPii: true,
  ignoreErrors: SHARED_IGNORE_ERRORS,
  // Drop errors whose stack originates entirely in injected wallet-extension
  // scripts (MetaMask `inpage.js` etc.) — see SHARED_DENY_URLS. CUSTOMER-UI-3R.
  denyUrls: SHARED_DENY_URLS,
  beforeSend: sharedBeforeSend,
});

if (isSentryEnabled && typeof window !== "undefined") {
  // `app.ready` measurement on the pageload transaction, from the mark that
  // splashScreen/removeLoader.js drops when the boot splash first lifts.
  // Pass the members, never the `Sentry` namespace itself: a namespace used
  // as a value keeps every @sentry/nextjs export in the root chunk (+69 KB gz).
  installAppReadyMeasurement(
    {
      getActiveSpan: Sentry.getActiveSpan,
      getRootSpan: Sentry.getRootSpan,
      spanToJSON: Sentry.spanToJSON,
      setMeasurement: Sentry.setMeasurement,
    },
    () => sanitizeUrlForTelemetry(window.location.pathname)
  );
  // Gated on isSentryEnabled because addIntegration, unlike init, does not
  // check `enabled`: ungated, rrweb would record on localhost/E2E/mock mode.
  if (isSentryReplayEnabled) {
    installLazySentryReplay({ addIntegration: Sentry.addIntegration });
  }
}

// Stamp Sentry events with the active OTel trace ID so Sentry's UI can
// pivot to Kibana traces for the same user action. Without this the two
// systems would record events with different trace IDs and there'd be no
// way to cross-link them.
Sentry.addEventProcessor((event) => {
  const ctx = trace.getActiveSpan()?.spanContext();
  if (ctx?.traceId) {
    event.contexts = event.contexts ?? {};
    event.contexts.trace = {
      ...event.contexts.trace,
      trace_id: ctx.traceId,
      span_id: ctx.spanId,
    };
  }
  return event;
});

// Augmenter listener registered AFTER Sentry.init so captureMessage routes
// through an initialized client. Browser fires unhandledrejection in
// registration order; the SHARED_IGNORE_ERRORS regex suppresses the
// SDK's default capture so each event surfaces only as our augmented form.
//
// Two augmentations:
//
// 1. Opaque rejections (reason === null | undefined): captured as
//    "rejection.opaque" warning with location + visibility context.
// 2. KYC hardware failures (DOMException NotReadableError): captured as
//    "kyc.hardware" warning so compliance can monitor aggregate camera /
//    I-O failure rates without per-user permission-denial spam dominating
//    the dashboard.
if (typeof window !== "undefined") {
  window.addEventListener("unhandledrejection", (event) => {
    const reason: unknown = event.reason;

    if (reason === null || reason === undefined) {
      Sentry.withScope((scope) => {
        scope.setLevel("warning");
        scope.setTag("rejection.opaque", "true");
        scope.setExtra(
          "location",
          sanitizeUrlForTelemetry(window.location.href)
        );
        scope.setExtra("documentVisibility", document.visibilityState);
        Sentry.captureMessage("UnhandledRejection: opaque reason", "warning");
      });
      return;
    }

    if (reason instanceof Error && reason.name === "NotReadableError") {
      // Drop NotReadableError captures from known in-app webviews (GSA,
      // Facebook, Instagram, Telegram, etc.). These browsers do not
      // reliably expose the camera to embedded SDKs — the failure is
      // expected and not actionable. The user-facing amber warning on
      // /register and /welcome (<InAppBrowserWarning />) tells them to
      // switch browsers. See Sentry CUSTOMER-UI-36.
      if (isInAppBrowser()) return;
      Sentry.withScope((scope) => {
        scope.setLevel("warning");
        scope.setTag("kyc.hardware", "true");
        scope.setExtra(
          "location",
          sanitizeUrlForTelemetry(window.location.href)
        );
        scope.setExtra("errorMessage", reason.message);
        Sentry.captureMessage(
          "KYC hardware unavailable: NotReadableError",
          "warning"
        );
      });
    }
  });
}

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
